import { Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Box, Stack } from '@mui/material';
import { styled } from '@mui/styles';
import { useNavigate, useParams } from 'react-router-dom';

import { TextStyle, customScrollbarStyle } from '../../../assets/styles/custom.styles';
import chevronRight from '../../../assets/svg/chevronRightIcon.svg';
import { getLastActiveTime } from '../../../assets/utils/helpers';
import { TenantUserObject } from '../../../Page/customer/partner/customer/customerUserListPage';
import LoadingComponent from '../../common/loadingComponent';

interface CustomerUserListProps {
  isLoading: boolean;
  isError: boolean;
  errorText: string;
  list: Array<TenantUserObject>
}

const container = {
  border:'1px solid rgba(0, 0, 0, 0.16)',
  borderRadius: '8px',
  maxWidth: '100%',
  maxHeight: 'calc(100vh - 150px)',
  ...(customScrollbarStyle),
};
const isActive = (status: string) => {
  if (status === 'Active') 
    return {
      color:'#1ED07A',
      bgcolor:'#D2F6E4',
      padding:'.25rem .5rem',
      borderRadius: '50px',
      textAlign: 'center',
      width: 'fit-content',
    };
  else
    return {
      color:'#F90',
      bgcolor:'#FFEFD7',
      padding:'.25rem .5rem',
      borderRadius: '50px',
      textAlign: 'center',
      width: 'fit-content',
    };
};
const tableStyle = {
  maxHeight: 'calc(100vh - 300px)',
  overflowY:'auto',
};

const HeaderCell = styled(TableCell)({
  color: '#878787!important',
  fontSize: '14px',
  fontWeight: 500,
});
const BodyCell = styled(TableCell)({
  color: '#181818',
  fontSize: '14px',
  fontWeight: 500,
});


const CustomerUserList = ({ isLoading, isError, errorText, list }: CustomerUserListProps) => {
  const { slug } = useParams();
  const navigate = useNavigate();
  
  return (
    <Stack component={Paper} sx={container}>
      <Typography sx={{
        ...TextStyle.headerText, 
        padding: '1.5rem 1.25rem' }}
      >List of All Users
      </Typography>
      <TableContainer sx={customScrollbarStyle}>
        <Table stickyHeader sx={tableStyle}>
          <TableHead>
            <TableRow>
              <HeaderCell>User</HeaderCell>
              <HeaderCell>Department</HeaderCell>
              <HeaderCell>Last Active</HeaderCell>
              <HeaderCell sx={{ maxWidth:'50px' }}>Status</HeaderCell>
              <HeaderCell sx={{ textAlign: 'end', maxWidth:'10px' }}>Actions</HeaderCell>
            </TableRow>
          </TableHead>
          {!isLoading && !isError &&
            <TableBody>
              {Array.isArray(list) && list.length > 0 && 
              list.map(({ id, fullName, departmentName, lastActive, status }) => (
                <TableRow key={id}>
                  <BodyCell>{fullName ? fullName : '--'}</BodyCell>
                  <BodyCell sx={{ maxWidth:'100px' }}>{departmentName}</BodyCell>
                  <BodyCell sx={{ color: '#878787!important' }}>{getLastActiveTime(lastActive)}</BodyCell>
                  <BodyCell sx={{ maxWidth:'50px' }}>
                    <Typography 
                      sx={isActive(status)}>
                      {status}
                    </Typography>
                  </BodyCell>
                  <BodyCell sx={{ textAlign: 'end', maxWidth:'10px' }}>
                    <IconButton
                      onClick = {() => { navigate(`/customer/backoffice/customer/${slug}/user/${id}`);}}>
                      <Box component='img' src={chevronRight}/>
                    </IconButton>
                  </BodyCell>
                </TableRow>
              )) 
              }
            </TableBody>
          }
        </Table>
        {isLoading && <LoadingComponent isMinHeight/>}
        {!isLoading && isError &&
          <Typography sx={{
            textAlign: 'center',
            padding:'40px',
            color:'#FF5E56',
          }}>{errorText}</Typography>
        }
      </TableContainer>
    </Stack>
  );
};

export default CustomerUserList;
